import client from "../httpClient";
import { useContext } from "react";
import { UIStoreContext } from "../../context";

export type SoftwareUpdate = {
  name: string;
  last_modified: string;
  version_data: any;
};

type CalibrationsReportResponseType = any;

const normalizeSoftwareUpdates = (data: unknown): SoftwareUpdate[] => {
  if (!Array.isArray(data)) {
    return [];
  }
  return data
    .map((item) => {
      if (typeof item === "string") {
        return { name: item, last_modified: "" , version_data: {}};
      }
      if (item && typeof item === "object") {
        const record = item as { name?: string; last_modified?: string, version_data?:any };
        return {
          name: record.name ?? "",
          last_modified: record.last_modified ?? "",
          version_data: record.version_data?? {},
        };
      }
      return { name: "", last_modified: "" , version_data:{}};
    })
    .filter((item) => item.name !== "");
};

const updatesTable = {
  UpdatesReport: (): CalibrationsReportResponseType => {
    const uiStore = useContext(UIStoreContext);
    return client.Get(
      "updatesReport",
      [
        "updatesTable",
        uiStore.getStartDate(),
        uiStore.getEndDate(),
        uiStore.getSelectedSystem(),
        uiStore.getSelectedClass(),
        uiStore.getDetectionsTablePage(),
        uiStore.getDetectionTableSortDirection(),
      ],
      {
        system_id: uiStore.getSelectedSystem(),
        start_date: uiStore.getStartDate(),
        end_date: uiStore.getEndDate(),
        classification_filter: uiStore.getSelectedClass(),
        order: uiStore.getDetectionTableSortDirection(),
        offset:
          uiStore.getDetectionsTableRowsPerPage() *
          (uiStore.getDetectionsTablePage() - 1),
        sort_by: "time",
        limit: uiStore.getDetectionsTableRowsPerPage(),
        location: uiStore.getFilterLocation(),
        label: uiStore.getDateFilter().label,
      },
      {
        enabled: uiStore.getSelectedSystem() !== "",
        placeholderData: [],
        keepPreviousData: true,
        staleTime: 0,
        cacheTime:0,
          manual:true
      }
    );
  },
  GetAvailableSoftwareUpdates: (systemType?: number, system_id?: string, enabled = true) => {
    const uiStore = useContext(UIStoreContext);
    const deviceType = systemType ?? uiStore.getSelectedSystemType();
    const resolvedSystemId = system_id ?? uiStore.getSelectedSystem();
    const response = client.Get(
      "updateAction",
      ["updateAction", deviceType, resolvedSystemId],
      {
        system_type: deviceType,
        system_id: resolvedSystemId,
      },
      { staleTime: 0, cacheTime: 0, enabled, refetchOnMount: "always" }
    );

    return {
      ...response,
      data: response.data ? normalizeSoftwareUpdates(response.data) : [],
    };
  },

};

export default updatesTable;
